import Repository from "./Repository";

export default {
  getFanStats() {
    return Repository.get(`fans_stats`);
  },
};
